import { IModuleMetaData } from "./company-module";

export class ModuleOnlineBackup {
	private metadata:IModuleMetaData;

	private constructor(metadata:IModuleMetaData){
		this.metadata = metadata;
	}

	public static create(metadata:IModuleMetaData):ModuleOnlineBackup{
		return new ModuleOnlineBackup(metadata || {});
	}

	public getLastBackupDate():Date | null {
		let unixDate = this.metadata["last-backup-date"];
		if (!unixDate) {
			return null;
		}
		return new Date(parseInt(unixDate)*1000);
	}

	public setLastBackupDate(date:Date | null):ModuleOnlineBackup{
		if (date == null){
			this.metadata["last-backup-date"] = "";
		}else{
			this.metadata["last-backup-date"] = `${Math.round(date.getTime() /1000)}`;
		}
		return this;
	}
}